import { useCatalog } from "catalog/Catalog.context";
import { twMerge } from "tailwind-merge";
import {
  CatalogLink,
  CatalogAutoplayButton,
  CatalogPagingButton,
} from "catalog/CatalogNavigations";
import { Image, Anime } from "./elements";
import { useParams } from "react-router-dom";

export default function GlobalNavigation() {
  const { activePageInfo, isResponsive } = useCatalog();
  const { nestedPageName } = useParams();
  const {
    depth1,
    depth2,
    haederBgState,
    gnbState,
    logoTheme,
    logoCiTheme,
    prodTheme,
    buttonTheme,
  } = activePageInfo;

  return (
    <div className="pointer-events-none absolute left-0 top-0 h-full w-full">
      <header
        className={twMerge(
          "header absolute z-[99999] flex h-[252px] w-full justify-between gap-8 pl-[153px] pr-[100px] pt-[50px] *:pointer-events-auto",
          "mo:fixed mo:h-[60px] mo:py-[15px] mo:pl-[15px] mo:pr-[15px] ",
          depth1 !== "cover" && "mo:bg-[#c01722]",
        )}
      >
        <Anime
          anime="fadeRight"
          className={`header-bg pg-bg ${haederBgState ? "haeder-bg-hide" : ""}`}
        >
          <Image
            src={
              depth1 === "product"
                ? "common/header-product.png"
                : ["about", "history"].includes(depth2)
                  ? "common/header-company.png"
                  : ["business", "valued-clients", "global-network"].includes(depth2)
                    ? "common/header-biz.png"
                    : depth1 === "cbm-services"
                      ? "common/header-cbm.png"
                      : ""
            }
          ></Image>
        </Anime>
        <Anime
          animate={{
            x: isResponsive
              ? 0
              : depth1 === "index" || depth1 === "intro" || depth1 === "end"
                ? -54
                : 0,
          }}
          className={"mo:flex"}
        >
          <CatalogLink to="cover/scene1">
            {(isResponsive ? depth1 !== "cover" : depth1 !== "end" && depth1 !== "cover") && (
              <svg
                className={"mo:h-auto mo:w-[100px]"}
                xmlns="http://www.w3.org/2000/svg"
                width="174.377"
                height="60.434"
                viewBox="0 0 174.377 60.434"
              >
                <path
                  d="M0,0-20.671-11.934a6.711,6.711,0,0,0-3.087-.759,6.718,6.718,0,0,0-3.088.759L-47.516,0a6.763,6.763,0,0,0-3.308,5.817V29.256h0a6.764,6.764,0,0,0,3.308,5.817L-27.153,46.83a6.745,6.745,0,0,0,3.4.911,6.737,6.737,0,0,0,3.39-.908L0,35.073a6.763,6.763,0,0,0,3.308-5.817V5.817A6.763,6.763,0,0,0,0,0M-8.437,19.958l-15.327,17.88-.007-9.283A3.381,3.381,0,0,0-25.279,26L-38.821,16.97a1.343,1.343,0,0,1-.531-1.065,1.345,1.345,0,0,1,.261-.79L-23.764-2.764l0,9.028,0-.017a3.38,3.38,0,0,0,1.526,2.828h0L-8.707,18.1a1.342,1.342,0,0,1,.531,1.064,1.339,1.339,0,0,1-.261.791"
                  transform="translate(50.824 12.693)"
                  fill={isResponsive ? "#fff" : logoCiTheme === "white" ? "#fff" : "#c30216"}
                />
                <path
                  d="M8842.208,9810.106v-20.272h-.079l-7.135,20.272h-7.44l-7.138-20.272h-.076v20.272h-8.5V9783h13.212l6.189,17.882h.073L8837.5,9783h13.211v27.107Zm-62.07,0V9783h20.043a14.142,14.142,0,0,1,4.614.665,7.778,7.778,0,0,1,3.095,1.881,7.446,7.446,0,0,1,1.726,2.847,12.043,12.043,0,0,1,.057,7.021,7.9,7.9,0,0,1-1.612,2.885,7.524,7.524,0,0,1-2.979,2.031,12.082,12.082,0,0,1-4.48.741h-11.426v9.036Zm9.036-14.654h8.048a3.894,3.894,0,0,0,2.753-.817,4.386,4.386,0,0,0,0-5.2,3.894,3.894,0,0,0-2.753-.815h-8.048Zm-20.384,14.654-1.635-4.405h-11.842l-1.633,4.405H8744L8755.769,9783h11.045l11.655,27.107Zm-11.352-10.023h7.593l-3.76-10.249h-.076Z"
                  transform="translate(-8676.332 -9766.335)"
                  fill={isResponsive ? "#fff" : logoTheme === "white" ? "#fff" : "#1b1b27"}
                />
              </svg>
            )}
          </CatalogLink>
        </Anime>
        <div className={`gnb-container ${gnbState ? "gnbState-hide" : ""}`}>
          <div className="gnb-bar">
            <CatalogLink to="about" className={`gnb-btn ${depth1 === "company" ? "active" : ""}`}>
              Company
            </CatalogLink>
            <CatalogLink
              to="products/content1"
              className={`gnb-btn ${depth1 === "product" ? "active" : ""} ${prodTheme ? "text-white" : ""}`}
            >
              Products
            </CatalogLink>
            <CatalogLink
              to="pd-diagnostic"
              className={`gnb-btn ${depth1 === "cbm" ? "active" : ""}`}
            >
              SERVICES
            </CatalogLink>
          </div>
          <div className={`lnb-container ${prodTheme ? "prodTheme" : ""}`}>
            <div className={`lnb-bar ${depth1 === "company" ? "active" : ""} `}>
              <CatalogLink to="about" className={`lnb-btn ${depth2 === "about" ? "active" : ""}`}>
                About APM
              </CatalogLink>
              <CatalogLink
                to="history"
                className={`lnb-btn ${depth2 === "history" ? "active" : ""}`}
              >
                History
              </CatalogLink>
              <CatalogLink
                to="business"
                className={`lnb-btn ${depth2 === "business" ? "active" : ""}`}
              >
                Business
              </CatalogLink>
              <CatalogLink
                to="valuedClients"
                className={`lnb-btn ${depth2 === "valued-clients" ? "active" : ""}`}
              >
                Valued Clients
              </CatalogLink>
              <CatalogLink
                to="globalNetwork"
                className={`lnb-btn ${depth2 === "global-network" ? "active" : ""}`}
              >
                Global Network
              </CatalogLink>
            </div>
            <div className={`lnb-bar ${depth1 === "product" ? "active" : ""} `}>
              <CatalogLink
                to="products/content1"
                className={`lnb-btn ${depth2 === "products" ? "active" : ""}`}
              >
                Products
              </CatalogLink>

              <CatalogLink to="lineup" className={`lnb-btn ${depth2 === "lineup" ? "active" : ""}`}>
                Product line-up _ PDMS
              </CatalogLink>
              <CatalogLink
                to="apm7000"
                className={`lnb-btn ${depth2 === "apm7000" ? "active" : ""}`}
              >
                APM 7000
              </CatalogLink>
              <CatalogLink
                to="apm7000P"
                className={`lnb-btn ${depth2 === "apm7000p" ? "active" : ""}`}
              >
                APM 7000P
              </CatalogLink>
              <CatalogLink
                to="apm5000"
                className={`lnb-btn ${depth2 === "apm5000" ? "active" : ""}`}
              >
                APM 5000
              </CatalogLink>
              <CatalogLink
                to="apm3000"
                className={`lnb-btn ${depth2 === "apm3000" ? "active" : ""}`}
              >
                APM 3000
              </CatalogLink>
              <CatalogLink
                to="apm2000"
                className={`lnb-btn ${depth2 === "apm2000" ? "active" : ""}`}
              >
                APM 2000
              </CatalogLink>
              <CatalogLink
                to="apm1200"
                className={`lnb-btn ${depth2 === "apm1200" ? "active" : ""}`}
              >
                APM 1200
              </CatalogLink>
              <CatalogLink
                to="sensor/internal"
                className={`lnb-btn ${depth2 === "sensor" ? "active" : ""}`}
              >
                SENSOR
              </CatalogLink>
            </div>
            <div className={`lnb-bar ${depth1 === "cbm-services" ? "active" : ""} `}>
              <CatalogLink
                to="pd-diagnostic"
                className={`lnb-btn ${depth2 === "pd-diagnostic" ? "active" : ""}`}
              >
                PD Diagnostic Service
              </CatalogLink>
              <CatalogLink
                to="available"
                className={`lnb-btn ${depth2 === "available" ? "active" : ""}`}
              >
                Available services
              </CatalogLink>
              <CatalogLink
                to="service-cases"
                className={`lnb-btn ${depth2 === "service-cases" ? "active" : ""}`}
              >
                Service Cases
              </CatalogLink>
            </div>
          </div>
        </div>
        <nav className="etc-nav ml-auto flex items-start gap-4">
          <CatalogLink to="index" className="etc-btn mt-[3px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35.2"
              height="31.545"
              viewBox="0 0 35.2 31.545"
              className="mb-[2px] mo:w-[20px]"
            >
              <path
                d="M0,0H35.2"
                transform="translate(0 1)"
                fill="rgba(0,0,0,0)"
                stroke={
                  isResponsive && nestedPageName === "scene4"
                    ? "#887e77"
                    : isResponsive
                      ? "#fff"
                      : buttonTheme === "gray"
                        ? "#887e77"
                        : "#fff"
                }
                strokeWidth="2"
              />
              <path
                d="M0,0H35.2"
                transform="translate(0 15.772)"
                fill="rgba(0,0,0,0)"
                stroke={
                  isResponsive && nestedPageName === "scene4"
                    ? "#887e77"
                    : isResponsive
                      ? "#fff"
                      : buttonTheme === "gray"
                        ? "#887e77"
                        : "#fff"
                }
                strokeWidth="2"
              />
              <path
                d="M0,0H35.2"
                transform="translate(0 30.545)"
                fill="rgba(0,0,0,0)"
                stroke={
                  isResponsive && nestedPageName === "scene4"
                    ? "#887e77"
                    : isResponsive
                      ? "#fff"
                      : buttonTheme === "gray"
                        ? "#887e77"
                        : "#fff"
                }
                strokeWidth="2"
              />
            </svg>
          </CatalogLink>
          <CatalogLink to="cover" className="etc-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40.316"
              viewBox="0 0 40 40.316"
              className="mo:w-[20px]"
            >
              <path
                d="M0,0V24.126H30.135V0"
                transform="translate(4.656 15.19)"
                fill="none"
                stroke={
                  isResponsive && nestedPageName === "scene4"
                    ? "#887e77"
                    : isResponsive
                      ? "#fff"
                      : buttonTheme === "gray"
                        ? "#887e77"
                        : "#fff"
                }
                strokeWidth="2"
              />
              <path
                d="M0,0-19.595-18.1-38.633-.017"
                transform="translate(39.322 19.471)"
                fill="none"
                stroke={
                  isResponsive && nestedPageName === "scene4"
                    ? "#887e77"
                    : isResponsive
                      ? "#fff"
                      : buttonTheme === "gray"
                        ? "#887e77"
                        : "#fff"
                }
                strokeWidth="2"
              />
            </svg>
          </CatalogLink>
        </nav>
      </header>
      <nav
        className={twMerge(
          "pagi-nav absolute bottom-0 left-0 z-[99999] flex w-full justify-between px-6 py-10 *:pointer-events-auto",
          "mo:fixed mo:px-2 mo:py-2",
          depth1 === "cover" ? "transparent" : "",
        )}
      >
        <CatalogPagingButton direction="prev" className="navi-btn disabled:opacity-50">
          <svg
            className={twMerge("mo:w-[25px]")}
            xmlns="http://www.w3.org/2000/svg"
            width="37.353"
            height="24.377"
            viewBox="0 0 37.353 24.377"
          >
            <path
              d="M0,0H35"
              transform="translate(2.353 12.176)"
              fill="none"
              stroke={
                nestedPageName === "scene4" ? "#887e77" : depth1 === "cover" ? "#fff" : "#887e77"
              }
              strokeWidth="2"
            />
            <path
              d="M0,0-11.481,11.481,0,22.963"
              transform="translate(12.895 0.707)"
              fill="none"
              stroke={
                nestedPageName === "scene4" ? "#887e77" : depth1 === "cover" ? "#fff" : "#887e77"
              }
              strokeWidth="2"
            />
          </svg>
        </CatalogPagingButton>
        <CatalogPagingButton direction="next" className="navi-btn disabled:opacity-50">
          <svg
            className={twMerge("mo:w-[25px]")}
            xmlns="http://www.w3.org/2000/svg"
            width="37.353"
            height="24.377"
            viewBox="0 0 37.353 24.377"
          >
            <path
              d="M0,0,11.481,11.481,0,22.963"
              transform="translate(24.458 0.707)"
              fill="none"
              stroke={
                nestedPageName === "scene4" ? "#887e77" : depth1 === "cover" ? "#fff" : "#887e77"
              }
              strokeWidth="2"
            />
            <path
              d="M0,0H-35"
              transform="translate(35 12.176)"
              fill="none"
              stroke={
                nestedPageName === "scene4" ? "#887e77" : depth1 === "cover" ? "#fff" : "#887e77"
              }
              strokeWidth="2"
            />
          </svg>
        </CatalogPagingButton>
      </nav>
    </div>
  );
}
